import './ScrollTop.css'

const ScrollTop = () => {
    return (
        <a className='Top' href='#'>
            <img src='../media/arrow-top.png' alt='top' />
        </a>
    )

}

export default ScrollTop